import React, { useEffect, useMemo, useState } from 'react';
import { useIsFetching } from 'react-query';
import LinearProgress from './core/LinearProgress';

const FetchIndicator: React.FC = () => {
  const isFetching = useIsFetching();

  const [max, setMax] = useState(0);
  useEffect(() => {
    if (isFetching === 0) {
      setMax(0);
      return;
    }
    if (isFetching > max) {
      setMax(isFetching);
    }
  }, [isFetching, max]);

  const progress = useMemo(
    () => (max > 0 ? 100 - (isFetching / max) * 100 : 0),
    [isFetching, max],
  );

  return (
    <div
      hidden={isFetching === 0}
      className="fixed bottom-0 left-0 z-[999999] w-full"
    >
      <LinearProgress value={progress} />
    </div>
  );
};

export default FetchIndicator;
